import * as React from 'react'

// A bug in the paywall UI must never blank the app: the boundary logs and
// renders nothing, the rest of the page keeps working.
export default class PaywallBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { failed: false }
    }
    static getDerivedStateFromError() {
        return { failed: true }
    }
    componentDidCatch(error) {
        console.error('[paywall] UI failed and was unmounted:', error)
    }
    render() {
        return this.state.failed ? null : this.props.children
    }
}
